<template>
  <div class="creatorButtons">
    <div class="title">Actions</div>
    <button class="action" @click="createNewVisualizer">
      + New Visualizer
    </button>
    <button class="action" @click="createNewKanban">+ New Kanban</button>
    <button class="action" @click="createNewEmail">+ New Email</button>
  </div>
</template>

<script>
import VisualizerHelpers from "../pages/Visualizer/VisualizerHelpers";
import KanbanHelpers from "../pages/Kanban/KanbanHelpers";
import EmailHelpers from "../pages/EmailManager/EmailHelpers";

export default {
  name: "CreatorButtons",
  methods: {
    async createNewVisualizer() {
      const visualizerId = await VisualizerHelpers.createNewVisualizer();
      console.log("@visualizerId", visualizerId);
      this.$router.push(`/visualizer/${visualizerId}`);
    },

    async createNewKanban() {
      const kanbanId = await KanbanHelpers.createNewKanban();
      console.log("@kanbanId", kanbanId);
      this.$router.push(`/kanban/${kanbanId}`);
    },

    async createNewEmail() {
      const emailId = await EmailHelpers.createNewEmail();
      console.log("@emailId", emailId);
      this.$router.push(`/emails/${emailId}`);
    },
  },
};
</script>

<style scoped>
.creatorButtons {
  display: inline-flex;
  flex-direction: column;
  /* border: 1px solid; */
  padding: 10px;
  margin-left: 5px;
  margin-right: 5px;
}

.creatorButtons button {
  cursor: pointer;
}

.creatorButtons .title {
  margin-bottom: 5px;
}

.creatorButtons .action {
  margin-bottom: 2.5px;
  margin-top: 2.5px;
  text-align: left;
}
</style>